var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-baselayers"},[_c('div',{staticClass:"map-baselayers__title"},[_vm._v(" Подложки ")]),_c('ul',{staticClass:"map-baselayers__list"},_vm._l((_vm.baselayers),function(layer){return _c('li',{key:layer.id,class:[
        _vm.baselayerId === layer.id ? 'active' : '',
        'map-baselayers__item'
      ],on:{"click":function($event){$event.stopPropagation();return _vm.clickHandler(layer)}}},[_vm._v(" "+_vm._s(layer.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }